// Debug flag - set to true to enable console logs
const DEBUG_ENABLED = false;

export const debug = {
  log: (...args: any[]) => {
    if (DEBUG_ENABLED) {
      console.log(...args);
    }
  }
};
